// extracted by mini-css-extract-plugin
export default {"root":"ModalHeader-root-a17d08b2a60bf3755d276bf5ce4fc871"};